import types from './types'

export const updateLoginPassword = (password) => ({ type: types.UPDATE_LOGIN_PASSWORD, password })
export const updateLoginUsername = (username) => ({ type: types.UPDATE_LOGIN_USERNAME, username })

export const loginAttempt = (username, password, token) => ({ type: types.LOGIN_ATTEMPT, username, password, token })
export const loginSuccess = (user) => ({ type: types.LOGIN_SUCCESS, user })
export const loginFailure = (error, code) => ({ type: types.LOGIN_FAILURE, error, code })

export const refreshAuth = (password) => ({ type: types.REFRESH_AUTH_ATTEMPT, password })
export const refreshAuthSuccess = (user) => ({ type: types.REFRESH_AUTH_SUCCESS, user })
export const refreshAuthFailure = (error, code) => ({ type: types.REFRESH_AUTH_FAILURE, error, code })
export const refreshAuthTotpRequired = (token) => ({ type: types.REFRESH_AUTH_TOTP_REQUIRED, token })

export const refreshAuthTotp = (totpCode) => ({ type: types.REFRESH_AUTH_TOTP_ATTEMPT, totpCode })
export const refreshAuthTotpSuccess = (user) => ({ type: types.REFRESH_AUTH_TOTP_SUCCESS, user })
export const refreshAuthTotpFailure = (error, code) => ({ type: types.REFRESH_AUTH_TOTP_FAILURE, error, code })

export const updateUser = (user) => ({ type: types.USERS_UPDATE_USER, user })

export const resetPassword = (password, token) => ({ type: types.RESET_PASSWORD_ATTEMPT, password, token })
export const resetPasswordSuccess = () => ({ type: types.RESET_PASSWORD_SUCCESS })
export const resetPasswordFailure = (error, code) => ({ type: types.RESET_PASSWORD_FAILURE, error, code })

export const activateUser = (username, forename, surname, password, code, id) => ({ type: types.ACTIVATE_USER_ATTEMPT, username, forename, surname, password, code, id })
export const activateUserSuccess = () => ({ type: types.ACTIVATE_USER_SUCCESS })
export const activateUserFailure = (error, code) => ({ type: types.ACTIVATE_USER_FAILURE, error, code })

export const activateUserWithJwt = (username, forename, surname, password, token) => ({ type: types.ACTIVATE_USER_JWT_ATTEMPT, username, forename, surname, password, token })
export const activateUserWithJwtSuccess = () => ({ type: types.ACTIVATE_USER_JWT_SUCCESS })
export const activateUserWithJwtFailure = (error, code) => ({ type: types.ACTIVATE_USER_JWT_FAILURE, error, code })

export const logoutAttempt = (message) => ({ type: types.LOGOUT_ATTEMPT, message})
export const logoutSuccess = (message) => ({ type: types.LOGOUT_SUCCESS, message })

export const sessionLoginAttempt = () => ({ type: types.SESSION_LOGIN_ATTEMPT })
export const sessionLoginSuccess = (user) => ({ type: types.SESSION_LOGIN_SUCCESS, user })
export const sessionLoginFailure = () => ({ type: types.SESSION_LOGIN_FAILURE })

export const authenticateTotpLoginAttempt = (code, fingerPrint, isTrustDevice, sessionId) => ({ type: types.AUTHENTICATE_TOTP_LOGIN_ATTEMPT , code, fingerPrint, isTrustDevice, sessionId})
export const authenticateTotpLoginSuccess = () => ({ type: types.AUTHENTICATE_TOTP_LOGIN_SUCCESS })
export const authenticateTotpLoginFailure = () => ({ type: types.AUTHENTICATE_TOTP_LOGIN_FAILURE })

export const signUpAttempt = (email, password, companyName, name, countryName, countryCode, phone, locale, industry, token) =>
    ({ type: types.SIGN_UP_ATTEMPT, email, password, companyName, name, countryName, countryCode, phone, locale, industry, token })

export const signUpFailure = (error, code) => ({ type: types.SIGN_UP_FAILURE, error, code })
export const signUpSuccess = (user) => ({ type: types.SIGN_UP_SUCCESS, user })

export const userDataReadAttempt = () => ({ type: types.USER_DATA_READ_ATTEMPT })
export const userDataReadFailure = (message, code) => ({ type: types.USER_DATA_READ_FAILURE, message, code })
export const userDataReadSuccess = (user) => ({ type: types.USER_DATA_READ_SUCCESS, user })

export const forgotPasswordAttempt = (username) => ({ type: types.FORGOT_PASSWORD_ATTEMPT, username })
export const forgotPasswordFailure = (message, code) => ({ type: types.FORGOT_PASSWORD_FAILURE, message, code })
export const forgotPasswordSuccess = (data) => ({ type: types.FORGOT_PASSWORD_SUCCESS, data: { result: data } })

export const updateSignUpPassword = (password) => ({ type: types.UPDATE_SIGN_UP_PASSWORD, password })
export const updateSignUpPasswordRepeat = (password_repeat) => ({ type: types.UPDATE_SIGN_UP_PASSWORD_REPEAT, password_repeat })
export const updateSignUpUsername = (username) => ({ type: types.UPDATE_SIGN_UP_USERNAME, username })
export const updateSignUpCompany = (company) => ({ type: types.UPDATE_SIGN_UP_COMPANY, company })
export const updateSignUpFullName = (fullname) => ({ type: types.UPDATE_SIGN_UP_FULLNAME, fullname })

export const showTfaLoginForm = () => ({type: types.SHOW_TFA_LOGIN_FORM})
export const hideTfaLoginForm = () => ({type: types.HIDE_TFA_LOGIN_FORM})

export const createPricingCalculatorAccessToken = (scope) => ({ type: types.PRICING_CALCULATOR_ACCESS_TOKEN_CREATE_ATTEMPT, scope })
export const createPricingCalculatorAccessTokenSuccess = (token) => ({ type: types.PRICING_CALCULATOR_ACCESS_TOKEN_CREATE_SUCCESS, token })
export const createPricingCalculatorAccessTokenFailure = (message, code) => ({ type: types.PRICING_CALCULATOR_ACCESS_TOKEN_CREATE_FAILURE, message, code })

export default {
  updateLoginPassword,
  updateLoginUsername,
  loginAttempt,
  loginSuccess,
  loginFailure,
  logoutAttempt,
  logoutSuccess,
  sessionLoginAttempt,
  sessionLoginSuccess,
  sessionLoginFailure,
  userDataReadAttempt,
  userDataReadFailure,
  userDataReadSuccess,
  forgotPasswordAttempt,
  forgotPasswordFailure,
  forgotPasswordSuccess,
  updateSignUpPassword,
  updateSignUpPasswordRepeat,
  updateSignUpUsername,
  updateSignUpCompany,
  updateSignUpFullName,
  onShowTfaTotpForm: showTfaLoginForm,
  createPricingCalculatorAccessToken,
}
